// Chinese Radicals (Simplified) - Based on MandarinPoster.com Radicals Chart
// Organized by stroke count for learning progression

export const radicals = [
  // 1 Stroke
  { char: '一', pinyin: 'yī', meaning: 'One', example: '1 stroke' },
  { char: '丨', pinyin: 'shù', meaning: 'Downstroke', example: '1 stroke' },
  { char: '丶', pinyin: 'diǎn', meaning: 'Dot', example: '1 stroke' },
  { char: '丿', pinyin: 'piě', meaning: 'Slash', example: '1 stroke' },
  { char: '乙', pinyin: 'yǐ', meaning: 'Bent', example: '1 stroke | variants: 乚, 乛' },

  // 2 Strokes
  { char: '二', pinyin: 'èr', meaning: 'Two', example: '2 strokes' },
  { char: '十', pinyin: 'shí', meaning: 'Ten', example: '2 strokes' },
  { char: '厂', pinyin: 'hǎn', meaning: 'Cliff', example: '2 strokes' },
  { char: '匚', pinyin: 'fāng', meaning: 'Basket', example: '2 strokes' },
  { char: '刂', pinyin: 'dāo', meaning: 'Knife', example: '2 strokes | variants: 刀, ⺈' },
  { char: '卜', pinyin: 'bǔ', meaning: 'Divination', example: '2 strokes' },
  { char: '冂', pinyin: 'jiōng', meaning: 'Borders', example: '2 strokes' },
  { char: '亻', pinyin: 'rén', meaning: 'Person', example: '2 strokes | variant: 人' },
  { char: '八', pinyin: 'bā', meaning: 'Eight', example: '2 strokes | variant: 丷' },
  { char: '儿', pinyin: 'ér', meaning: 'Legs', example: '2 strokes' },
  { char: '几', pinyin: 'jī', meaning: 'Table', example: '2 strokes' },
  { char: '匕', pinyin: 'bǐ', meaning: 'Spoon', example: '2 strokes' },
  { char: '勹', pinyin: 'bāo', meaning: 'Wrap', example: '2 strokes' },
  { char: '亠', pinyin: 'tóu', meaning: 'Lid', example: '2 strokes' },
  { char: '冫', pinyin: 'bīng', meaning: 'Ice', example: '2 strokes' },
  { char: '冖', pinyin: 'mì', meaning: 'Cover', example: '2 strokes' },
  { char: '凵', pinyin: 'kǎn', meaning: 'Container', example: '2 strokes' },
  { char: '卩', pinyin: 'jié', meaning: 'Seal', example: '2 strokes | variant: 㔾' },
  { char: '阝', pinyin: 'fù/yì', meaning: 'Mound (left) / Town (right)', example: '2 strokes' },
  { char: '力', pinyin: 'lì', meaning: 'Power', example: '2 strokes' },
  { char: '又', pinyin: 'yòu', meaning: 'Right-hand', example: '2 strokes' },
  { char: 'ㄙ', pinyin: 'sī', meaning: 'Privacy', example: '2 strokes' },
  { char: '讠', pinyin: 'yán', meaning: 'Speech', example: '2 strokes | variant: 言' },

  // 3 Strokes
  { char: '廴', pinyin: 'yǐn', meaning: 'Stride', example: '3 strokes' },
  { char: '干', pinyin: 'gān', meaning: 'Shield', example: '3 strokes' },
  { char: '土', pinyin: 'tǔ', meaning: 'Earth', example: '3 strokes' },
  { char: '士', pinyin: 'shì', meaning: 'Scholar', example: '3 strokes' },
  { char: '工', pinyin: 'gōng', meaning: 'Work', example: '3 strokes' },
  { char: '扌', pinyin: 'shǒu', meaning: 'Hand', example: '3 strokes | variants: 手, 龵' },
  { char: '艹', pinyin: 'cǎo', meaning: 'Grass', example: '3 strokes' },
  { char: '寸', pinyin: 'cùn', meaning: 'Thumb/Inch', example: '3 strokes' },
  { char: '廾', pinyin: 'gǒng', meaning: 'Two-hands', example: '3 strokes' },
  { char: '大', pinyin: 'dà', meaning: 'Big', example: '3 strokes' },
  { char: '尢', pinyin: 'wāng', meaning: 'Lame', example: '3 strokes' },
  { char: '弋', pinyin: 'yì', meaning: 'Shoot', example: '3 strokes' },
  { char: '小', pinyin: 'xiǎo', meaning: 'Small', example: '3 strokes | variants: ⺌, ⺍' },
  { char: '口', pinyin: 'kǒu', meaning: 'Mouth', example: '3 strokes' },
  { char: '囗', pinyin: 'wéi', meaning: 'Enclosure', example: '3 strokes' },
  { char: '山', pinyin: 'shān', meaning: 'Mountain', example: '3 strokes' },
  { char: '巾', pinyin: 'jīn', meaning: 'Scarf', example: '3 strokes' },
  { char: '川', pinyin: 'chuān', meaning: 'River', example: '3 strokes | variant: 巛' },
  { char: '彳', pinyin: 'chì', meaning: 'Step', example: '3 strokes' },
  { char: '彡', pinyin: 'shān', meaning: 'Bristle', example: '3 strokes' },
  { char: '犭', pinyin: 'quǎn', meaning: 'Dog', example: '3 strokes | variant: 犬' },
  { char: '夂', pinyin: 'zhǐ', meaning: 'Go', example: '3 strokes' },
  { char: '饣', pinyin: 'shí', meaning: 'Food', example: '3 strokes | variant: 食' },
  { char: '氵', pinyin: 'shuǐ', meaning: 'Water', example: '3 strokes | variants: 水, 氺' },
  { char: '忄', pinyin: 'xīn', meaning: 'Heart', example: '3 strokes | variants: 心, ⺗' },
  { char: '宀', pinyin: 'mián', meaning: 'Roof', example: '3 strokes' },
  { char: '辶', pinyin: 'chuò', meaning: 'Walk', example: '3 strokes' },
  { char: '彐', pinyin: 'jì', meaning: 'Snout', example: '3 strokes' },
  { char: '尸', pinyin: 'shī', meaning: 'Corpse', example: '3 strokes' },
  { char: '己', pinyin: 'jǐ', meaning: 'Self', example: '3 strokes | variants: 已, 巳' },
  { char: '弓', pinyin: 'gōng', meaning: 'Bow', example: '3 strokes' },
  { char: '子', pinyin: 'zǐ', meaning: 'Child', example: '3 strokes | variant: 孑' },
  { char: '屮', pinyin: 'chè', meaning: 'Sprout', example: '3 strokes' },
  { char: '女', pinyin: 'nǚ', meaning: 'Woman', example: '3 strokes' },
  { char: '纟', pinyin: 'sī', meaning: 'Silk', example: '3 strokes | variant: 糸' },
  { char: '马', pinyin: 'mǎ', meaning: 'Horse', example: '3 strokes' },
  { char: '幺', pinyin: 'yāo', meaning: 'Little', example: '3 strokes' },
  { char: '广', pinyin: 'yǎn', meaning: 'Shelter', example: '3 strokes' },
  { char: '门', pinyin: 'mén', meaning: 'Gate', example: '3 strokes' },
  { char: '丬', pinyin: 'qiáng', meaning: 'Splinter', example: '3 strokes' },
  { char: '夕', pinyin: 'xī', meaning: 'Evening', example: '3 strokes' },

  // 4 Strokes
  { char: '王', pinyin: 'wáng', meaning: 'King', example: '4 strokes' },
  { char: '韦', pinyin: 'wéi', meaning: 'Leather', example: '4 strokes' },
  { char: '耂', pinyin: 'lǎo', meaning: 'Old', example: '4 strokes' },
  { char: '木', pinyin: 'mù', meaning: 'Tree', example: '4 strokes' },
  { char: '歹', pinyin: 'dǎi', meaning: 'Death/Bad', example: '4 strokes' },
  { char: '车', pinyin: 'chē', meaning: 'Car', example: '4 strokes' },
  { char: '牙', pinyin: 'yá', meaning: 'Fang', example: '4 strokes' },
  { char: '戈', pinyin: 'gē', meaning: 'Halberd', example: '4 strokes' },
  { char: '比', pinyin: 'bǐ', meaning: 'Compare', example: '4 strokes' },
  { char: '瓦', pinyin: 'wǎ', meaning: 'Tile', example: '4 strokes' },
  { char: '止', pinyin: 'zhǐ', meaning: 'Stop', example: '4 strokes' },
  { char: '攴', pinyin: 'pū', meaning: 'Tap', example: '4 strokes | variant: 攵' },
  { char: '日', pinyin: 'rì', meaning: 'Sun', example: '4 strokes' },
  { char: '曰', pinyin: 'yuē', meaning: 'Say', example: '4 strokes' },
  { char: '贝', pinyin: 'bèi', meaning: 'Shell', example: '4 strokes' },
  { char: '见', pinyin: 'jiàn', meaning: 'See', example: '4 strokes' },
  { char: '牛', pinyin: 'niú', meaning: 'Cow', example: '4 strokes | variant: 牜' },
  { char: '毛', pinyin: 'máo', meaning: 'Fur', example: '4 strokes' },
  { char: '气', pinyin: 'qì', meaning: 'Steam', example: '4 strokes' },
  { char: '片', pinyin: 'piàn', meaning: 'Slice', example: '4 strokes' },
  { char: '斤', pinyin: 'jīn', meaning: 'Axe', example: '4 strokes' },
  { char: '爪', pinyin: 'zhǎo', meaning: 'Claw', example: '4 strokes | variant: 爫' },
  { char: '父', pinyin: 'fù', meaning: 'Father', example: '4 strokes' },
  { char: '月', pinyin: 'yuè/ròu', meaning: 'Moon/Meat', example: '4 strokes' },
  { char: '欠', pinyin: 'qiàn', meaning: 'Yawn', example: '4 strokes' },
  { char: '风', pinyin: 'fēng', meaning: 'Wind', example: '4 strokes' },
  { char: '殳', pinyin: 'shū', meaning: 'Lance', example: '4 strokes' },
  { char: '文', pinyin: 'wén', meaning: 'Literature', example: '4 strokes' },
  { char: '方', pinyin: 'fāng', meaning: 'Square', example: '4 strokes' },
  { char: '火', pinyin: 'huǒ', meaning: 'Fire', example: '4 strokes | variant: 灬' },
  { char: '斗', pinyin: 'dǒu', meaning: 'Dipper', example: '4 strokes' },
  { char: '礻', pinyin: 'shì', meaning: 'Sign', example: '4 strokes | variant: 示' },
  { char: '户', pinyin: 'hù', meaning: 'Door', example: '4 strokes | variant: 戶' },
  { char: '肀', pinyin: 'yù', meaning: 'Brush', example: '4 strokes | variants: ⺻, 聿' },

  // 5 Strokes
  { char: '毋', pinyin: 'wú', meaning: 'Do not', example: '5 strokes' },
  { char: '石', pinyin: 'shí', meaning: 'Stone', example: '5 strokes' },
  { char: '龙', pinyin: 'lóng', meaning: 'Dragon', example: '5 strokes' },
  { char: '业', pinyin: 'yè', meaning: 'Business', example: '5 strokes' },
  { char: '目', pinyin: 'mù', meaning: 'Eye', example: '5 strokes' },
  { char: '田', pinyin: 'tián', meaning: 'Field', example: '5 strokes' },
  { char: '皿', pinyin: 'mǐn', meaning: 'Dish', example: '5 strokes' },
  { char: '罒', pinyin: 'wǎng', meaning: 'Net', example: '5 strokes' },
  { char: '钅', pinyin: 'jīn', meaning: 'Gold', example: '5 strokes | variant: 金' },
  { char: '生', pinyin: 'shēng', meaning: 'Life', example: '5 strokes' },
  { char: '矢', pinyin: 'shǐ', meaning: 'Arrow', example: '5 strokes' },
  { char: '禾', pinyin: 'hé', meaning: 'Grain', example: '5 strokes' },
  { char: '白', pinyin: 'bái', meaning: 'White', example: '5 strokes' },
  { char: '瓜', pinyin: 'guā', meaning: 'Melon', example: '5 strokes' },
  { char: '用', pinyin: 'yòng', meaning: 'Use', example: '5 strokes' },
  { char: '鸟', pinyin: 'niǎo', meaning: 'Bird', example: '5 strokes' },
  { char: '疒', pinyin: 'nè', meaning: 'Sickness', example: '5 strokes' },
  { char: '立', pinyin: 'lì', meaning: 'Stand', example: '5 strokes' },
  { char: '穴', pinyin: 'xué', meaning: 'Cavern', example: '5 strokes' },
  { char: '衤', pinyin: 'yī', meaning: 'Clothes', example: '5 strokes | variant: 衣' },
  { char: '疋', pinyin: 'pǐ', meaning: 'Cloth', example: '5 strokes | variant: ⺪' },
  { char: '皮', pinyin: 'pí', meaning: 'Skin', example: '5 strokes' },
  { char: '矛', pinyin: 'máo', meaning: 'Spear', example: '5 strokes' },
  { char: '母', pinyin: 'mǔ', meaning: 'Mother', example: '5 strokes' },

  // 6 Strokes
  { char: '耒', pinyin: 'lěi', meaning: 'Plough', example: '6 strokes' },
  { char: '耳', pinyin: 'ěr', meaning: 'Ear', example: '6 strokes' },
  { char: '臣', pinyin: 'chén', meaning: 'Minister', example: '6 strokes' },
  { char: '西', pinyin: 'xī', meaning: 'West', example: '6 strokes' },
  { char: '覀', pinyin: 'yà', meaning: 'Cover', example: '6 strokes' },
  { char: '页', pinyin: 'yè', meaning: 'Page', example: '6 strokes' },
  { char: '虍', pinyin: 'hū', meaning: 'Tiger', example: '6 strokes' },
  { char: '虫', pinyin: 'chóng', meaning: 'Insect', example: '6 strokes' },
  { char: '缶', pinyin: 'fǒu', meaning: 'Jar', example: '6 strokes' },
  { char: '舌', pinyin: 'shé', meaning: 'Tongue', example: '6 strokes' },
  { char: '⺮', pinyin: 'zhú', meaning: 'Bamboo', example: '6 strokes | variant: 竹' },
  { char: '臼', pinyin: 'jiù', meaning: 'Mortar', example: '6 strokes' },
  { char: '自', pinyin: 'zì', meaning: 'Self', example: '6 strokes' },
  { char: '血', pinyin: 'xuè', meaning: 'Blood', example: '6 strokes' },
  { char: '舟', pinyin: 'zhōu', meaning: 'Boat', example: '6 strokes' },
  { char: '羊', pinyin: 'yáng', meaning: 'Sheep', example: '6 strokes | variant: ⺶' },
  { char: '米', pinyin: 'mǐ', meaning: 'Rice', example: '6 strokes' },
  { char: '羽', pinyin: 'yǔ', meaning: 'Feather', example: '6 strokes' },
  { char: '艮', pinyin: 'gèn', meaning: 'Limit', example: '6 strokes' },

  // 7 Strokes
  { char: '麦', pinyin: 'mài', meaning: 'Wheat', example: '7 strokes' },
  { char: '走', pinyin: 'zǒu', meaning: 'Walk', example: '7 strokes' },
  { char: '赤', pinyin: 'chì', meaning: 'Red', example: '7 strokes' },
  { char: '豆', pinyin: 'dòu', meaning: 'Bean', example: '7 strokes' },
  { char: '酉', pinyin: 'yǒu', meaning: 'Wine', example: '7 strokes' },
  { char: '卤', pinyin: 'lǔ', meaning: 'Salt', example: '7 strokes' },
  { char: '豕', pinyin: 'shǐ', meaning: 'Swine', example: '7 strokes' },
  { char: '辰', pinyin: 'chén', meaning: 'Morning', example: '7 strokes' },
  { char: '身', pinyin: 'shēn', meaning: 'Body', example: '7 strokes' },
  { char: '足', pinyin: 'zú', meaning: 'Foot', example: '7 strokes' },
  { char: '里', pinyin: 'lǐ', meaning: 'Village', example: '7 strokes' },
  { char: '豸', pinyin: 'zhì', meaning: 'Cat', example: '7 strokes' },
  { char: '谷', pinyin: 'gǔ', meaning: 'Valley', example: '7 strokes' },
  { char: '釆', pinyin: 'biàn', meaning: 'Divide', example: '7 strokes' },
  { char: '角', pinyin: 'jiǎo', meaning: 'Horn', example: '7 strokes' },
  { char: '辛', pinyin: 'xīn', meaning: 'Bitter', example: '7 strokes' },

  // 8 Strokes
  { char: '青', pinyin: 'qīng', meaning: 'Blue/green', example: '8 strokes' },
  { char: '鱼', pinyin: 'yú', meaning: 'Fish', example: '8 strokes' },
  { char: '隹', pinyin: 'zhuī', meaning: 'Small bird', example: '8 strokes' },
  { char: '雨', pinyin: 'yǔ', meaning: 'Rain', example: '8 strokes' },
  { char: '其', pinyin: 'qí', meaning: 'Clear', example: '8 strokes' },
  { char: '齿', pinyin: 'chǐ', meaning: 'Tooth', example: '8 strokes' },

  // 9 Strokes
  { char: '髟', pinyin: 'biāo', meaning: 'Hair', example: '9 strokes' },
  { char: '音', pinyin: 'yīn', meaning: 'Sound', example: '9 strokes' },
  { char: '骨', pinyin: 'gǔ', meaning: 'Bone', example: '9 strokes' },
  { char: '革', pinyin: 'gé', meaning: 'Rawhide', example: '9 strokes' },
  { char: '鬼', pinyin: 'guǐ', meaning: 'Ghost', example: '9 strokes' },

  // 10+ Strokes
  { char: '鬥', pinyin: 'dòu', meaning: 'Fight', example: '10 strokes' },
  { char: '鼻', pinyin: 'bí', meaning: 'Nose', example: '14 strokes' },
  { char: '鼠', pinyin: 'shǔ', meaning: 'Rat', example: '13 strokes' },
  { char: '鹿', pinyin: 'lù', meaning: 'Deer', example: '11 strokes' },
  { char: '麻', pinyin: 'má', meaning: 'Hemp', example: '11 strokes' },
  { char: '黑', pinyin: 'hēi', meaning: 'Black', example: '12 strokes' },
];
